<template>
  <!-- footer block -->

  <footer class="w3l-footer-29-main">
    <a
      href="//api.whatsapp.com/send?phone=917034554111&text=Hello"
      class="float"
      target="_blank"
    >
      <i class="bx bxl-whatsapp my-float"></i>
    </a>
    <div class="footer-29 pt-5 pb-4">
      <div class="container pt-md-4">
        <div class="row footer-top-29">
          <div class="col-lg-4 col-md-6 footer-list-29">
            <img
              src="@/assets/site/images/logo-white.png"
              class="img-fluid"
              alt=""
            />
            <p class="mb-2 pe-xl-5 pt-3">
              Accenta Education, 1st Floor, PNP Square, Opp. Punjab National
              Bank, North Chalakudy, Kerala 680307.
            </p>
            <p class="mb-2">
              Phone Number : <a href="tel:7034554111">+91 7034554111</a>,
              <a href="tel:7034513111">+91 7034513111</a>
            </p>
            <p class="mb-2">
              Email : <a href="mailto:info@accenta.in">info@accenta.in</a>
            </p>
            <!-- <img src="@/assets/site/images/iso.png" class=" iso-image"  alt=""> -->
          </div>
          <div class="col-lg-2 col-md-3 col-6 footer-list-29 mt-md-0 mt-4">
            <ul>
              <h6 class="footer-title-29">Quick Links</h6>
              <li><router-link to="/ielts">Courses</router-link></li>
              <li><router-link to="/schools">Services</router-link></li>
              <li><router-link to="/careers">Careers</router-link></li>
              <li><router-link to="/contact">Contact Us</router-link></li>
            </ul>
          </div>
          <div
            class="col-lg-2 col-md-3 col-6 ps-lg-5 ps-lg-4 footer-list-29 mt-md-0 mt-4"
          >
            <ul>
              <h6 class="footer-title-29">Explore</h6>
              <li>
                <a href="https://youtube.com/@AccentaEducation" target="_blank"
                  >Youtube</a
                >
              </li>
              <li>
                <router-link to="/privacy-policy">Privacy policy</router-link>
              </li>
              <li><router-link to="/admissions">Admissions</router-link></li>
              <li>
                <router-link to="/about">About Us</router-link>
              </li>
            </ul>
          </div>
          <div
            class="col-lg-4 col-md-6 col-sm-8 footer-list-29 mt-lg-0 mt-4 ps-lg-5 d-none d-sm-block"
          >
            <h6 class="footer-title-29">Location</h6>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15701.555546559004!2d76.3371003!3d10.3107296!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b080241947d9153%3A0x1e74db030c989632!2sAccenta%20Education!5e0!3m2!1sen!2sin!4v1678467387780!5m2!1sen!2sin"
              width="350"
              height="250"
              style="border: 10px"
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
        <div class="rounded-social-buttons pt-4">
          <a
            class="social-button facebook"
            href="https://www.facebook.com/accenta"
            target="_blank"
            ><i class="fab fa-facebook-f"></i
          ></a>
          <a
            class="social-button x-twitter"
            href="https://x.com/accentaedu"
            target="_blank"
            ><!-- Bundled Font Awesome (6.3) predates the X glyph, so the
              brand mark ships inline; path is FA's x-twitter icon. -->
            <svg viewBox="0 0 512 512" aria-label="X" role="img">
              <path
                fill="currentColor"
                d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
              /></svg
          ></a>
          <a
            class="social-button linkedin"
            href="https://www.linkedin.com/in/accenta-education-3856b5263"
            target="_blank"
            ><i class="fab fa-linkedin"></i
          ></a>
          <a
            class="social-button youtube"
            href="https://youtube.com/@AccentaEducation"
            target="_blank"
            ><i class="fab fa-youtube"></i
          ></a>
          <a
            class="social-button instagram"
            href="https://instagram.com/accenta_education"
            target="_blank"
            ><i class="fab fa-instagram"></i
          ></a>
        </div>
        <!-- copyright -->
        <p class="copy-footer-29 text-center pt-lg-2 mt-5 pb-2">
          © {{ new Date().getFullYear() }} Accenta Education. All Rights
          Reserved. Developed by
          <a href="https://www.oracloud.in/" target="_blank">Oracloud</a>
        </p>
        <!-- //copyright -->
      </div>
    </div>
  </footer>
  <!-- //footer block -->
</template>
<script>
export default {
  name: "FooterBar",
};
</script>
<style scoped>
.router-link-active {
  color: #fbb034 !important;
  border-bottom: 2px solid var(--primary);
  display: inline-block !important;
}
</style>
